import { articlesCollection } from '../../config/firebase';

let state = {
	article: {},
	articles: [],
	featuredArticles: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	article: state => state.article,
	articles: state => state.articles,
	featuredArticles: state => state.featuredArticles,
	articleLoading: state => state.loading,
	articleNotification: state => state.notification,
};
let actions = {
	async getArticle({ commit }, payload) {
		commit('setArticleLoading', true);
		let articleSnap = await articlesCollection.doc(payload).get();
		let articleData = articleSnap.data();
		commit('setArticleData', articleData);
		commit('setArticleLoading', false);
	},
	async getArticles({ commit }) {
		commit('setArticleLoading', true);
		articlesCollection.onSnapshot(snapshot => {
			let articles = [];
			for (let doc of snapshot.docs) {
				articles.push({ id: doc.id, ...doc.data() });
			}
			commit('setArticlesData', articles);
			commit('setArticleLoading', false);
		});
	},
	async getFeaturedArticles({ commit }) {
		commit('setArticleLoading', true);
		articlesCollection
			.where('isActive', '==', true)
			.onSnapshot(snapshot => {
				let articles = [];
				for (let doc of snapshot.docs) {
					articles.push({ id: doc.id, ...doc.data() });
				}
				commit('setFeaturedArticlesData', articles);
				commit('setArticleLoading', false);
			});
	},
};
let mutations = {
	setArticleData(state, payload) {
		state.article = payload;
	},
	setArticlesData(state, payload) {
		state.articles = payload;
	},
	setFeaturedArticlesData(state, payload) {
		state.featuredArticles = payload;
	},
	setArticleLoading(state, payload) {
		state.loading = payload;
	},
	setArticlesNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
